import { CustomImage } from '@app/components/various/CustomImage';
import { Help } from '@app/components/various/Help';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Product } from '@typings';

interface Props {
  name: string;
  attributesDetails: Product.AttributeDetails[];
}

export const AttributeName = ({ name, attributesDetails }: Props) => {
  return (
    <div className="whitespace-nowrap pr-4 text-left uppercase text-neutral-60 body-6">
      {name}
      {!isEmpty(attributesDetails) && (
        <Help placement="top-center">
          {attributesDetails.map(attributeDetails => {
            return (
              <span className="flex flex-col items-center justify-center gap-1" key={attributeDetails.desc}>
                {isDefined(attributeDetails.image) && (
                  <div className="w-16">
                    <CustomImage aspectRatio={1} src={attributeDetails.image.url} />
                  </div>
                )}
                {attributeDetails.desc}
              </span>
            );
          })}
        </Help>
      )}
    </div>
  );
};
